import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

interface ForgotPasswordRequest {
    email: string;
}

interface ResetPasswordRequest {
    resetToken: string;
    newPassword: string;
}

interface ResetPasswordResponse {
    message: string;
}

@Injectable({ providedIn: 'root' })
export class PasswordService {
    private http = inject(HttpClient);
    private apiUrl = `${environment.apiUrl}/password`;

    forgotPassword(email: string): Observable<void> {
        return this.http.post<void>(`${this.apiUrl}/forgot`, { email });
    }

    resetPassword(data: ResetPasswordRequest): Observable<ResetPasswordResponse> {
        return this.http.post<ResetPasswordResponse>(`${this.apiUrl}/reset`, data);
    }
}
